import React from 'react';
import './StatusBadge.css';

const StatusBadge = ({ status, type = 'charge' }) => { // ✅ type 파라미터 추가
  const getStatusInfo = (status, type) => {
    if (type === 'charge') {
      switch (status) {
        case 'PENDING':
          return { text: '입금대기중', className: 'charge-PENDING' };
        case 'APPROVED':
          return { text: '지급완료', className: 'charge-APPROVED' };
        case 'REJECTED':
          return { text: '취소', className: 'charge-REJECTED' };
        default:
          return { text: status, className: 'status-default' };
      }
    } else if (type === 'refund') {
      switch (status) {
        case 'PENDING':
          return { text: '확인중', className: 'refund-PENDING' };
        case 'APPROVED':
          return { text: '환불완료', className: 'refund-APPROVED' };
        case 'REJECTED':
          return { text: '반려', className: 'refund-REJECTED' };
        default:
          return { text: status, className: 'status-default' };
      }
    } else {
      // 기본값 (하위 호환성)
      switch (status) {
        case 'PENDING':
          return { text: '대기중', className: 'charge-PENDING' };
        case 'APPROVED':
          return { text: '완료', className: 'charge-APPROVED' };
        case 'REJECTED':
          return { text: '취소', className: 'charge-REJECTED' };
        default:
          return { text: status, className: 'status-default' };
      }
    }
  };

  const { text, className } = getStatusInfo(status, type);

  return <span className={`status-badge ${className}`}>{text}</span>;
};

export default StatusBadge;
